import styled from 'styled-components'
import { IconAnnouncement } from '@edulastic/icons'
import {
  extraDesktopWidthMax,
  mediumDesktopExactWidth,
  smallDesktopWidth,
} from '@edulastic/colors'

export const MfaNoticeIcon = styled(IconAnnouncement)`
  flex-shrink: 0;
  color: inherit;
  margin-bottom: -6px;
  margin-right: 6px;

  && {
    width: 1.5em;
    min-width: 1.5em;
    height: 1.5em;
  }

  g {
    opacity: 1;
  }

  path {
    fill: currentColor;
  }
`

const MfaNotice = styled.p`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #a97c00;
  text-align: left;
  font-style: normal;
  font-weight: 500;
  width: 100%;
`

export const MfaLearnMoreLink = styled.a`
  color: inherit;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;
  font-weight: 600;
  font-family: Open Sans;
  line-height: 130%;

  &:hover,
  &:focus,
  &:active,
  &:visited {
    color: inherit;
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 2px;
  }
`

export const MfaNoticeSignup = styled(MfaNotice)`
  font-size: 15px;
  margin: 11px -10px 0 -10px;
  line-height: 170%;
  margin-bottom: 24px;
  margin-top: -28px;

  ${MfaLearnMoreLink} {
    font-size: 15px;
  }
`

export const MfaNoticeLogin = styled(MfaNotice)`
  font-size: 10px;
  margin: 15px -15px -5px -15px;
  line-height: 170%;
  width: 115%;
  @media (min-width: ${smallDesktopWidth}) {
    font-size: 11px;
  }
  @media (min-width: ${mediumDesktopExactWidth}) {
    font-size: 12px;
  }
  @media (min-width: ${extraDesktopWidthMax}) {
    font-size: 14px;
  }

  ${MfaLearnMoreLink} {
    font-size: 10px;
    @media (min-width: ${smallDesktopWidth}) {
      font-size: 11px;
    }
    @media (min-width: ${mediumDesktopExactWidth}) {
      font-size: 12px;
    }
    @media (min-width: ${extraDesktopWidthMax}) {
      font-size: 13px;
    }
  }
  ${MfaNoticeIcon} {
    margin-right: 3px;
    margin-bottom: -4px;
    @media (min-width: ${mediumDesktopExactWidth}) {
      margin-right: 4px;
      margin-bottom: -5px;
    }
    @media (min-width: ${extraDesktopWidthMax}) {
      margin-right: 6px;
    }
  }
`
